export const cardFragment = `
  fragment cardFragment on CardRecord {
    __typename
    id
    button {
      __typename
      ... on ButtonRecord {
        ...buttonFragment
      }
      ... on FlatButtonRecord {
        ...flatButtonFragment
      }
    }
    content {
      blocks
      links
      value
    }
    maxContentLines
    hexagonLeft {
      backgroundColor
    }
    hexagonRight {
      backgroundColor
    }
    leftBadge {
      text
      background
    }
    mediaM: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 173
        }
      ) {
        ...responsiveImageFragment
      }
    }
    mediaL: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 268
        }
      ) {
        ...responsiveImageFragment
      }
    }
    mediaXL: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 272
        }
      ) {
        ...responsiveImageFragment
      }
    }
    media2XL: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 328
        }
      ) {
        ...responsiveImageFragment
      }
    }
    media3XL: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 363
        }
      ) {
        ...responsiveImageFragment
      }
    }
    media4XL: media {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 552
        }
      ) {
        ...responsiveImageFragment
      }
    }
    note
    progress
    rightBadge {
      text
      background
    }
    size
    subtitle
    tags {
      tag
    }
    title
    titleMaxLines
  }
`;
